// Importação dos hooks do React e bibliotecas necessárias
import React, { useEffect, useState } from 'react';
import Images from "../../img/imagens"; // Importa imagens utilizadas na página
import './App.css'; // Estilos específicos da tela inicial
import axios from 'axios'; // Biblioteca para requisições HTTP
import 'bootstrap/dist/css/bootstrap.min.css'; // Estilos do Bootstrap
import { Modal, ModalBody, ModalFooter, ModalHeader, Card, CardBody, CardTitle, CardText, Row, Col } from 'reactstrap'; // Componentes do Reactstrap
import { Link } from 'react-router-dom'; // Navegação entre rotas

export default function TelaInicial() {
    // URLs da API
    const baseurl = "http://10.80.12.5:81/api" // URL base da API Produção
    //const baseurl = "https://localhost:44304/api"; // URL base da API DEV

    // Estados do componente
    const [data, setData] = useState([]); // Lista de colaboradores
    const [pesquisa, setPesquisa] = useState(''); // Texto de pesquisa para colaboradores
    const [noticias, setNoticias] = useState([]); // Lista de notícias/comunicados
    const [dataRes, setDataRes] = useState([]); // Lista de reservas de salas
    //const [salaStatus, setSalaStatus] = useState({}); // Estado para armazenar status das salas (não utilizado)
    const [loading, setLoading] = useState(true); // Estado de carregamento
    const [error, setError] = useState(null); // Estado de erro
    const [showModal, setShowModal] = useState(false); // Controle do modal da área do servidor
    const [isButtonModalOpen, setIsButtonModalOpen] = useState(false); // Controle do modal de seleção de relatórios Power BI
    const [isIframeModalOpen, setIsIframeModalOpen] = useState(false); // Controle do modal do iframe Power BI
    const [iframeIndex, setIframeIndex] = useState(0); // Índice do relatório Power BI selecionado
    const [salas, setSalas] = useState([]); // Lista de salas de reunião

    // Função para buscar as salas do banco de dados
    const buscarSalasNoBanco = async () => {
        try {
            const response = await axios.get(`${baseurl}/Sala`); // Busca todas as salas
            return response.data.map(sala => ({
                id: sala.salaId, // ID da sala
                nome: `Sala ${sala.nomeSala}`,
                status: sala.statusSala // Status da sala (disponível/indisponível)
            }));
        } catch (error) {
            console.error("Erro ao buscar salas:", error);
            return [];
        }
    };

    // Lista de relatórios Power BI disponíveis
    const powerBiReports = [
        { name: "CAF", url: "https://app.powerbi.com/view?r=eyJrIjoiYjI1NjEyYTQtMTYyMy00NDhhLWI3YjgtY2VlNDNmYmVjYmZkIiwidCI6ImU3YWE5MmI1LWZmZmItNGY1OC1iZTRjLWE0YzNmMTdkNDBkYSJ9" },
        { name: "AUDI", url: "https://app.powerbi.com/view?r=eyJrIjoiZDIyMDEyMTAtMDAxNS00MzBhLTk2NDktNTg3NWI2NmU5Y2Q3IiwidCI6ImU3YWE5MmI1LWZmZmItNGY1OC1iZTRjLWE0YzNmMTdkNDBkYSJ9" },
        { name: "COPI", url: "https://app.powerbi.com/view?r=eyJrIjoiZWRhMTkxZjEtMDM2Ni00MjVjLWE3MDAtZjY4ZDYyYmY1NjAzIiwidCI6ImU3YWE5MmI1LWZmZmItNGY1OC1iZTRjLWE0YzNmMTdkNDBkYSJ9" },
        { name: "COR", url: "https://app.powerbi.com/view?r=eyJrIjoiOWIxMWYwZDAtOTYzNi00ZmU1LTliZWUtYmFhMTQzOGZmOGNhIiwidCI6ImU3YWE5MmI1LWZmZmItNGY1OC1iZTRjLWE0YzNmMTdkNDBkYSJ9" },
        { name: "GAB", url: "https://app.powerbi.com/view?r=eyJrIjoiYzNlZmQ2MjQtOTZjNy00ODZlLWJlYjktNjQ0Y2Y4ODI2MzY4IiwidCI6ImU3YWE5MmI1LWZmZmItNGY1OC1iZTRjLWE0YzNmMTdkNDBkYSJ9" },
        { name: "OUVI", url: "https://app.powerbi.com/view?r=eyJrIjoiMTY1MGM3NjUtZmI3NS00NTlkLWI0MjctMzVhMDA2NzBhYjFkIiwidCI6ImU3YWE5MmI1LWZmZmItNGY1OC1iZTRjLWE0YzNmMTdkNDBkYSJ9" },
    ];

    // Função utilitária para formatar datas para o padrão YYYY-MM-DD
    const formatarData = (dataString) => {
        if (!dataString) return '';

        // Se já estiver no formato correto, retorna
        if (/^\d{4}-\d{2}-\d{2}$/.test(dataString)) {
            return dataString;
        }

        // Se estiver no formato DD/MM/YYYY, converte
        if (dataString.includes('/')) {
            const [dia, mes, ano] = dataString.split('/');
            return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        }

        return dataString;
    };

    // Data atual no formato YYYY-MM-DD
    const dataAtual = new Date().toISOString().split('T')[0];

    // Função para buscar dados dos colaboradores
    const pedidoGet = async () => {
        try {
            const response = await axios.get(`${baseurl}/Colaborador`); // Busca todos os colaboradores
            setData(response.data);
        } catch (error) {
            console.error("Erro ao buscar colaboradores:", error);
        }
    };

    // Função para buscar notícias/comunicados
    const comunicadoGet = async () => {
        try {
            const response = await axios.get(`${baseurl}/noticia`); // Busca todas as notícias
            setNoticias(response.data);
        } catch (error) {
            console.error("Erro ao buscar notícias:", error);
        }
    };

    // Função para buscar reservas de salas
    const ReservaGet = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${baseurl}/Reserva`); // Busca todas as reservas

            if (response.data) {
                // Formata as datas das reservas
                const reservasFormatadas = response.data.map(reserva => ({
                    ...reserva,
                    dataFormatada: formatarData(reserva.dataReserva)
                }));

                setDataRes(reservasFormatadas);
            } else {
                console.log("A resposta da solicitação GET está vazia.");
            }
        } catch (error) {
            console.error("Erro ao buscar reservas:", error);
            setError("Erro ao carregar reservas. Tente novamente mais tarde.");
        } finally {
            setLoading(false);
        }
    };

    // Função para verificar o status de uma sala específica
    const verificarStatusSala = async (salaId) => {
        try {
            const response = await axios.get(`${baseurl}/Sala/${salaId}`); // Busca status da sala
            return response.data.statusSala;
        } catch (error) {
            console.error(`Erro ao verificar status da sala ${salaId}:`, error);
            return false; // Retorna false em caso de erro
        }
    };

    // Atualiza o status de todas as salas
    const atualizarStatusSalas = async () => {
        const salasAtualizadas = await Promise.all(
            salas.map(async (sala) => {
                const status = await verificarStatusSala(sala.id);
                return { ...sala, status };
            })
        );
        setSalas(salasAtualizadas);
    };

    // Carrega todos os dados quando o componente monta
    useEffect(() => {
        const carregarDados = async () => {
            try {
                await Promise.all([
                    pedidoGet(), // Busca colaboradores
                    comunicadoGet(), // Busca comunicados
                    ReservaGet(), // Busca reservas
                    atualizarStatusSalas() // Atualiza status das salas
                ]);
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        const carregarSalas = async () => {
            const salasFormatadas = await buscarSalasNoBanco(); // Busca e formata salas
            setSalas(salasFormatadas);
        };
        carregarSalas();
        carregarDados();
    }, []);

    // -------------------- COMPONENTES INTERNOS --------------------

    // Componente para exibir comunicados recentes
    const FeedComunicados = () => {
        return (
            <div className="FeedComunicados">
                <div className="row">
                    {noticias.slice(0, 3).map((noticia) => (
                        <div className="mb-4 col-md-4" key={noticia.noticiaId}>
                            <Card>
                                <CardBody>
                                    {/* Exibe imagem da notícia, se houver */}
                                    {noticia.imagemBase64 && (
                                        <img
                                            src={noticia.imagemBase64.startsWith('data:image')
                                                ? noticia.imagemBase64
                                                : `data:image/png;base64,${noticia.imagemBase64}`}
                                            alt={noticia.titulo}
                                            className="card-img-top"
                                            style={{ height: "50px", objectFit: "cover" }}
                                        />
                                    )}
                                    <CardTitle tag="h5" className="TituloNoticia">
                                        {noticia.titulo}
                                    </CardTitle>
                                </CardBody>
                            </Card>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // Componente para exibir lista de funcionários filtrados
    const TodosFuncionarios = () => {
        // Filtra colaboradores pelo nome pesquisado
        const funcionariosFiltrados = data.filter(colaborador =>
            colaborador.nome.toLowerCase().includes(pesquisa.toLowerCase())
        );

        return (
            <div className='tabelacolaboradores'>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Telefone</th>
                            <th>Unidade</th>
                            <th>Setor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {funcionariosFiltrados
                            .sort((a, b) => a.divisaoNome.localeCompare(b.divisaoNome))
                            .map(colaborador => (
                                <tr key={colaborador.colaboradorid}>
                                    <td>{colaborador.nome}</td>
                                    <td>
                                        {/* Formata ramal para 0000-0000 */}
                                        {colaborador.ramal
                                            ? String(colaborador.ramal).padStart(8, '0').replace(/(\d{4})(\d{4})/, '$1-$2')
                                            : ''}
                                    </td>
                                    <td>{colaborador.divisaoNome}</td>
                                    <td>{colaborador.setor}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        );
    };

    // Componente para exibir reservas por sala
    const ReservasPorSala = ({ sala }) => {
        // Filtra reservas da sala para o dia atual
        const reservasFiltradas = dataRes.filter(reserva =>
            reserva.salaId === sala.id && reserva.dataFormatada === dataAtual
        );

        return (
            <div className="row">
                <div className="col-md-12">
                    <table className="table">
                        <thead>
                            <tr>
                                <th colSpan={3}>
                                    {/* Exibe status da sala e nome */}
                                    {sala.status === null
                                        ? `Carregando ${sala.nome}...`
                                        : sala.status
                                            ? `Horários Reservados ${sala.nome} Hoje`
                                            : sala.nome}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sala.status === null ? (
                                <tr>
                                    <td colSpan="3">Carregando status...</td>
                                </tr>
                            ) : !sala.status ? (
                                <tr>
                                    <td colSpan="3">Sala Indisponível</td>
                                </tr>
                            ) : loading ? (
                                <tr>
                                    <td colSpan="3">Carregando reservas...</td>
                                </tr>
                            ) : error ? (
                                <tr>
                                    <td colSpan="3">{error}</td>
                                </tr>
                            ) : reservasFiltradas.length > 0 ? (
                                reservasFiltradas
                                    .slice(0, 3)
                                    .map(reserva => (
                                        <tr key={reserva.reservaId}>
                                            <td>Para: {reserva.colaboradorNome}</td>
                                            <td>Início: {reserva.horaInicio}</td>
                                            <td>Final: {reserva.horarioFinal}</td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan="3">Nenhuma reserva encontrada para hoje</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    // Função para abrir o modal do iframe Power BI
    const openIframeModal = (index) => {
        setIframeIndex(index);
        setIsIframeModalOpen(true);
    };

    // -------------------- RENDERIZAÇÃO PRINCIPAL --------------------
    // O restante do código JSX é responsável pela estrutura visual da tela inicial,
    // incluindo cabeçalho, sidebar, modais, quadros de comunicados, lista de telefone,
    // reservas de sala e FAQ de TI, além do rodapé com links institucionais.
    // Os comentários abaixo explicam cada bloco visual.

    return (
        <div className="App">
            <header className="App-header">
                <a href='https://www.prefeitura.sp.gov.br/cidade/secretarias/controladoria_geral/'
                    target='_blank'
                    rel="noopener noreferrer"
                    className='logolink'>
                    <img src={Images.CGM1} alt="Prefeitura" width="150" className='logo' />
                </a>
                <div className='links'>
                    <ul id="menu">
                        <li><a href='https://diariooficial.prefeitura.sp.gov.br/md_epubli_controlador.php?acao=inicio'
                            target='_blank'
                            rel="noopener noreferrer">Diário Oficial</a></li>
                        <li><a href='https://www.capital.sp.gov.br/noticias'
                            target='_blank'
                            rel="noopener noreferrer">Prefeitura Notícias</a></li>
                        <li><Link to="Chamado" className='botaoreserva'>Chamado DADM</Link></li>
                        <li><a href="#"
                            onClick={(e) => { e.preventDefault(); setShowModal(true); }}>Área do Servidor</a></li>
                    </ul>
                    <select id="dropdownMenu" style={{ display: 'none' }}></select>
                </div>
            </header>

            <div className="Sidebar">
                <ul>
                    <li>
                        <a href="http://citi.pmsp/index.php?redirect=%2Ffront%2Fticket.php&error=3"
                            target='blank'
                            rel="noopener noreferrer">
                            <img src={Images.citi} className='sidebarimg' alt="Citi" title="Ir para Citi"></img>
                        </a>
                    </li>
                    <li>
                        <a href="https://sip.prefeitura.sp.gov.br/sip/login.php?sigla_orgao_sistema=PMSP&sigla_sistema=SEI&infra_url=L3NlaS8="
                            target='blank'
                            rel="noopener noreferrer">
                            <img src={Images.sei} className='sidebarimg' alt="SEI" title="Ir para SEI"></img>
                        </a>
                    </li>
                    <li>
                        <a href="https://sigrc.prefeitura.sp.gov.br/auth-web/login?redirect_uri=https://sigrc.prefeitura.sp.gov.br/cube/api/auth/callback&token_aplicacao=otbkk4Z-n57rA3GUw9xr3A&requested_uri=https://sigrc.prefeitura.sp.gov.br/atendimento/receptivo/novo"
                            target='blank'
                            rel="noopener noreferrer">
                            <img src={Images.sigrc} className='sidebarimg' alt="SIGRC" title="Ir para SIGRC"></img>
                        </a>
                    </li>
                    <li>
                        <a href='https://simproc.prefeitura.sp.gov.br/Forms/login.aspx'
                            target='blank'
                            rel="noopener noreferrer">
                            <img src={Images.simproc} className='sidebarimg' alt="Simproc" title="Ir para Simproc"></img>
                        </a>
                    </li>
                    <li>
                        <a href='https://clic.prefeitura.sp.gov.br'
                            target='blank'
                            rel="noopener noreferrer">
                            <img src={Images.clic} className='sidebarimg' alt="Clic" title="Ir para Clic"></img>
                        </a>
                    </li>
                    <li>
                        <a href='http://sf8424.rede.sp/sof/'
                            target='blank'
                            rel="noopener noreferrer">
                            <img src={Images.sof} className='sidebarimg' alt="Sof" title="Ir para Sof"></img>
                        </a>
                    </li>
                    <li>
                        <img
                            src={Images.PBI}
                            className="sidebarimg"
                            alt="Power BI"
                            title="Paineis PowerBI"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsButtonModalOpen(true)}
                        />
                    </li>
                </ul>
            </div>

            {/* Modal Área do Servidor */}
            <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
                <ModalHeader toggle={() => setShowModal(false)}>
                    <h3 style={{ color: "#EC6608" }}>Área do Servidor</h3>
                </ModalHeader>
                <ModalBody>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li>
                            <a href="https://clic.prefeitura.sp.gov.br/storage/uploads/2024/09/03/Formul%C3%A1rio%20de%20Abono.pdf"
                                target="_blank"
                                rel="noopener noreferrer">
                                Formulário de Abono
                            </a>
                        </li>
                        <li>
                            <a href="https://www.areaprivada.prefeitura.sp.gov.br/PortalPMSP/PortalPMSP/Portal/PMSPprt001.tp"
                                target="_blank"
                                rel="noopener noreferrer">
                                Holerite
                            </a>
                        </li>
                        <li>
                            <a href="https://clic.prefeitura.sp.gov.br/manuais-e-formularios"
                                target="_blank"
                                rel="noopener noreferrer">
                                Manuais e Formulários
                            </a>
                        </li>
                    </ul>
                </ModalBody>
                <ModalFooter>
                    <button onClick={() => setShowModal(false)} className="btn btn-danger">
                        Fechar
                    </button>
                </ModalFooter>
            </Modal>

            {/* Modal de seleção de relatórios Power BI */}
            <Modal isOpen={isButtonModalOpen} toggle={() => setIsButtonModalOpen(false)}>
                <ModalHeader toggle={() => setIsButtonModalOpen(false)}>
                    <h3 style={{ color: "#EC6608" }}>Escolha um Relatório</h3>
                </ModalHeader>
                <ModalBody>
                    <div className="d-flex flex-wrap gap-2">
                        {powerBiReports.map((report, index) => (
                            <button
                                key={index}
                                onClick={() => openIframeModal(index)}
                                className="btn btn-primary">
                                {report.name}
                            </button>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        onClick={() => setIsButtonModalOpen(false)}
                        className="btn btn-danger">
                        Fechar
                    </button>
                </ModalFooter>
            </Modal>

            {/* Modal do iframe Power BI */}
            <Modal isOpen={isIframeModalOpen} toggle={() => setIsIframeModalOpen(false)} size="xl">
                <ModalHeader toggle={() => setIsIframeModalOpen(false)}>
                    {powerBiReports[iframeIndex].name}
                </ModalHeader>
                <ModalBody style={{ padding: 0 }}>
                    <div style={{ width: "100%", height: "70vh" }}>
                        <iframe
                            title={powerBiReports[iframeIndex].name}
                            src={powerBiReports[iframeIndex].url}
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                            }}
                            allowFullScreen={true}
                        ></iframe>
                    </div>
                </ModalBody>
            </Modal>

            <div className='Content'>
                <Row xs="1" md="2">
                    <Col sm="6">
                        <div className="quadro">
                            <div className='content-head'>
                                <h2>Comunicados &nbsp; </h2>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-newspaper" viewBox="0 0 16 16">
                                    <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z" />
                                    <path d="M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z" />
                                </svg>
                            </div>
                            <FeedComunicados />
                            <div className="d-flex justify-content-between mt-2">
                                <Link to="Comunicados">Acessar comunicados</Link>
                                <a href='https://ascomcgm.github.io/ClippingCGM/'
                                    target='_blank'
                                    rel="noopener noreferrer">Acessar Clipping do dia</a>
                            </div>
                        </div>
                    </Col>
                    <Col sm="6">
                        <div className="quadro">
                            <div className='content-head'>
                                <h2>Lista de Telefone&nbsp;</h2>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                </svg>
                                <div className="search-container">
                                    <input
                                        className='inputpesquisafunc'
                                        type="text"
                                        value={pesquisa}
                                        onChange={(e) => setPesquisa(e.target.value)}
                                        placeholder="Pesquisar nome"
                                    />
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                    </svg>
                                </div>
                            </div>
                            <TodosFuncionarios />
                        </div>
                    </Col>
                </Row>
                <Row xs="1" md="2">
                    <Col sm="6">
                        <div className="quadro">
                            <div className='content-head'>
                                <h2>Reserva Sala de Reunião &nbsp; </h2>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-calendar-plus" viewBox="0 0 16 16">
                                    <path d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7" />
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                </svg>
                                <Link to="ReservaSala" className='botaoreserva'>Reservar</Link>
                            </div>
                            <div className='ReservaSalaInic'>
                                <div className="containerReserva">
                                    {salas.map(sala => (
                                        <ReservasPorSala key={sala.id} sala={sala} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm="6">
                        <div className="quadro">
                            <div className='content-head'>
                                <h2>Resolução de Problemas (FAQ TI) &nbsp; </h2>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-wrench" viewBox="0 0 16 16">
                                    <path d="M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11z" />
                                </svg>
                            </div>
                            <div className='btnresprob'>
                                <Link to="/ResolucaoProblemas#vpn">Como conectar na VPN</Link>
                            </div>
                            <div className='btnresprob'>
                                <Link to="/ResolucaoProblemas#citi">Como abrir chamado no CITI</Link>
                            </div>
                            <div className='btnresprob'>
                                <Link to="/ResolucaoProblemas#add">Como adicionar a Intranet na área de trabalho</Link>
                            </div>
                            <div className='btnresprob'>
                                <Link to="ResolucaoProblemas">Como redefinir minha senha</Link>
                            </div>
                            <div className='btnresprob'>
                                <Link to="AssinaturaCard">
                                    Gerar minha assinatura
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-vector-pen" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z" />
                                        <path fillRule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086z" />
                                    </svg>
                                </Link>
                            </div>
                            <div className='footerquadro'>
                                <div className='btnresprobultimo'>
                                    <Link to="ResolucaoProblemas">Mais dúvidas</Link>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <footer className="footer">
                <a href='https://www.instagram.com/cgmsp/' className='footerlink' target='blank' rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" className="bi bi-instagram" viewBox="0 0 16 16">
                        <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                    </svg> @cgmsp
                </a>

                <a href='https://www.youtube.com/user/cgmsaopaulo' className='footerlink' target='blank' rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="bi bi-youtube" viewBox="0 0 16 16">
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                </svg> @cgmsaopaulo</a>
                <a href='https://www.facebook.com/cgmsp/?ref=hl' className='footerlink' target='blank' rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" class="bi bi-facebook" viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                </svg> @CGMSP</a>
                <a href='https://www.linkedin.com/company/106882140/admin/dashboard/' className='footerlink' target='blank' rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                    </svg> @CGMSP
                </a>
            </footer>
        </div>
    )
}